import { FC } from 'react';
import Skeleton, { SkeletonProps } from 'react-loading-skeleton';

const DgSkeleton: FC<SkeletonProps> = ({ ...props }) => {
	return <Skeleton {...props} />;
};

export default DgSkeleton;
